import HodaSolati from '@/assets/images/speakers/Hoda_Solati.jpg'
import JennaRitten from '@/data/2025/assets/images/team/jenna_ritten.webp'
import ShimaSolati from '@/assets/images/speakers/Shima_Solati.jpg'
import WScottRichardson from '@/assets/images/speakers/W_Scott_Richardson.jpeg'

export const SpeakersData = [
  {
    id: 1,
    name: 'W. Scott Richardson',
    email: 'zurielseven@gmail.com',
    avatar: WScottRichardson,
    bio: `W. Scott Richardson is an award-winning Aerospace Engineer, working for Altair Engineering as an Architect of Learning Experience Design for Computer Aided Engineering. Scott has been an active volunteer both as the Global Community Outreach chair for Altair's ABERN ERG community development as well as with the National Society of Black Engineers Metro Detroit chapter over the past half decade.\n\nWherever Scott goes, you'll find him teaching or learning, from core professional competencies to historical minutae, from Star Trek trivia to his latest hobbies. In this way, he hopes to give to the communities around him and better them.`,
    twitter: 'zurielseven',
    linkedIn: 'https://www.linkedin.com/in/zurielseven',
    organization: 'Altair Engineering',
    position: '',
    session: {
      title: 'Getting started with Microcontrollers and Sensors',
      abstract:
        "Ever thought about expanding on your software skills with hardware? Let's start with a Make-and-Take with lasers and microcontrollers! We'll teach some basics of electronics in a hands-on workshop while building and coding a light detector. Time to find your new maker path! (Laptop required)",
      description: `This workshop is for beginners to electronics that want to get their hands on something physical. We'll use a handful of simple pieces to assemble a Make-and-Take light detector that we can test with a laser. We'll code the microcontroller to pick up the analog signal from the laser. Why a laser? Well, we could test with a flashlight too, but lasers are just way cooler.\n\nAlong the way, we'll start from practically no electronics knowledge at all and discuss how and why these electronics work together the way that they do, ideate and improve code to make our microcontroller run, and practice good breadboarding skills. Let this be the start of a new maker identity!`,
      tags: [
        'Electronics',
        'Microcontrollers',
        'Lasers',
        'Basic Optics',
        'Getting Started',
        'Hands-On',
        'Take-Home',
      ],
      track: 'Innovation',
      time: '16:00',
      room: 'MCC4',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 2,
    name: 'Jenna Ritten',
    email: null,
    avatar: JennaRitten,
    bio: null,
    twitter: 'jritten',
    linkedIn: 'https://www.linkedin.com/in/jritten/',
    github: 'https://github.com/jritten',
    url: null,
    organization: 'IBM',
    position: 'Chief Developer Advocate & Senior Architect',
    session: {
      title: 'AI Hackathon Winners Presentations, Demos & Awards',
      abstract: null,
      description: null,
      tags: [],
      track: 'Level Up',
      time: '16:00',
      room: 'MCC2',
    },
    isWTM: true,
    isGDE: true,
    mastodon: null,
  },
  {
    id: 3,
    name: 'Hoda Solati',
    email: null,
    avatar: HodaSolati,
    bio: `Hoda Solati is an award-winning UX designer working at BraunAbility blending creativity, technology, and innovation to craft inclusive, user-centered experiences. With advanced degrees in UX Design and Animation, she explores cutting-edge technologies such as VR, AR, and robotics to solve complex design challenges. Recognized at global events including DDX’25 NYC, IEEE Smart Mobility, and Ars Electronica, Hoda is passionate about redefining the future of user experience through innovation and accessibility.`,
    twitter: null,
    linkedIn: 'https://www.linkedin.com/in/hoda-solati',
    url: null,
    organization: 'BraunAbility',
    position: 'UX Designer',
    session: {
      title: 'Design for AI Workshop',
      abstract: null,
      description: null,
      tags: [],
      track: 'Hackathon',
      time: '10:00',
      room: 'STEM Innovation Learning Center (SILC) - 7th Floor',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 4,
    name: 'Shima Solati',
    email: null,
    avatar: ShimaSolati,
    bio: `Shima Solati is an award-winning UX/UI designer and researcher at BraunAbility, leading efforts to advance mobility and accessibility through innovative, user-centered design. With a Master’s in User Experience Design from the College for Creative Studies and dual degrees in fashion and textiles, Shima brings a rare multidisciplinary perspective to solving complex challenges. Her expertise spans immersive and assistive technologies, VR, AR, robotics, and her portfolio includes impactful work for KUKA Robotics, the Augmented Reality Center, General Motors, and Ford. Passionate about inclusive design and emerging technologies, Shima is dedicated to creating intuitive solutions that empower all users.`,
    twitter: null,
    linkedIn: 'https://www.linkedin.com/in/shima-solati/',
    url: null,
    organization: 'BraunAbility',
    position: 'UX/UI Designer and Researcher',
    session: {
      title: 'Design for AI Workshop',
      abstract: null,
      description: null,
      tags: [],
      track: 'Hackathon',
      time: '10:00',
      room: 'STEM Innovation Learning Center (SILC) - 7th Floor',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 5,
    name: 'Steven Benyard',
    email: null,
    avatar: `https://placehold.co/600x400/0F9D58/FFFFFF?text=Steven+Benyard`,
    bio: 'Steven Benyard is Vice President of Electric Capital Delivery at DTE Energy, where he leads transformational initiatives in energy infrastructure and AI-driven innovation. A visionary Black leader in the energy sector, Steven is committed to creating equitable, sustainable energy solutions for Michigan communities.',
    twitter: null,
    linkedIn: null,
    url: null,
    organization: 'DTE Energy',
    position: 'Vice President - Electric Capital Delivery',
    session: {
      title:
        "Powering Detroit's Future: AI-Driven Energy Innovation Fireside Chat with DTE x IBM",
      abstract:
        'Innovation Summit Keynote exploring how artificial intelligence is revolutionizing the energy sector while creating unprecedented opportunities for Michigan communities.',
      description:
        "Join us for an inspiring keynote conversation between two visionary Black leaders transforming how Michigan powers its future. Steven Benyard and Jason Kelley will explore how AI is revolutionizing the energy sector, addressing equity through innovation, climate action, and building tomorrow's workforce.",
      tags: ['AI', 'Energy', 'Innovation', 'Leadership'],
      track: 'Leadership',
      time: '09:00',
      room: 'Main Stage',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 6,
    name: 'Jason Kelley',
    email: null,
    avatar: `https://placehold.co/600x400/0F9D58/FFFFFF?text=Jason+Kelley`,
    bio: 'Jason Kelley is the Global Head and Managing Partner of Core Business Applications at IBM. A transformational leader driving AI adoption and digital innovation at scale, Jason brings decades of experience helping enterprises leverage cutting-edge technology for business transformation.',
    twitter: null,
    linkedIn: null,
    url: null,
    organization: 'IBM',
    position: 'Global Head, Managing Partner - Core Business Applications',
    session: {
      title:
        "Powering Detroit's Future: AI-Driven Energy Innovation Fireside Chat with DTE x IBM",
      abstract:
        'Innovation Summit Keynote exploring how artificial intelligence is revolutionizing the energy sector while creating unprecedented opportunities for Michigan communities.',
      description:
        "Join us for an inspiring keynote conversation between two visionary Black leaders transforming how Michigan powers its future. Steven Benyard and Jason Kelley will explore how AI is revolutionizing the energy sector, addressing equity through innovation, climate action, and building tomorrow's workforce.",
      tags: ['AI', 'Energy', 'Innovation', 'Leadership'],
      track: 'Leadership',
      time: '09:00',
      room: 'Main Stage',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 7,
    name: 'Tabice Ward',
    email: null,
    avatar: `https://placehold.co/600x400/0F9D58/FFFFFF?text=Tabice+Ward`,
    bio: 'Tabice Ward serves as Chief Information Officer at Walker-Miller Energy Services, where she leads technology strategy and digital transformation initiatives. A champion for diversity in tech, Tabice brings expertise in leveraging technology to create equitable energy solutions.',
    twitter: null,
    linkedIn: null,
    url: null,
    organization: 'Walker-Miller Energy Services',
    position: 'Chief Information Officer',
    session: {
      title:
        "Powering Detroit's Future: AI-Driven Energy Innovation Fireside Chat with DTE x IBM",
      abstract:
        'Innovation Summit Keynote exploring how artificial intelligence is revolutionizing the energy sector while creating unprecedented opportunities for Michigan communities.',
      description:
        'Tabice Ward joins the keynote conversation as a moderator, bringing her expertise in technology leadership and energy equity to this inspiring discussion.',
      tags: ['AI', 'Energy', 'Innovation', 'Leadership'],
      track: 'Leadership',
      time: '09:00',
      room: 'Main Stage',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 8,
    name: 'Sylvester Hester',
    email: null,
    avatar: `https://placehold.co/600x400/0F9D58/FFFFFF?text=Sylvester+Hester`,
    bio: 'Sylvester Hester is the President and CEO of LM Manufacturing, a leading automotive supplier. A visionary business leader, Sylvester has built a reputation for excellence in manufacturing while championing workforce development and community investment in Detroit.',
    twitter: null,
    linkedIn: null,
    url: null,
    organization: 'LM Manufacturing',
    position: 'President & CEO',
    session: {
      title:
        'Catalysts and Change Agents: Extending the Impact of Your Tech Leadership',
      abstract:
        'Innovation Summit Panel Discussion on bridging the gap between technical excellence and social responsibility.',
      description:
        'This session offers a "system architecture" for repeatable community impact, teaching early- and mid-career professionals and tech leaders across industries how to draw on executive and managerial frameworks to strengthen the communities they serve.',
      tags: ['Leadership', 'Community', 'Impact'],
      track: 'Leadership',
      time: '13:00',
      room: 'Main Stage',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
  {
    id: 9,
    name: 'Justin Turk',
    email: null,
    avatar: `https://placehold.co/600x400/0F9D58/FFFFFF?text=Justin+Turk`,
    bio: 'Justin Turk is a 2X Tech Founder, having built ConStrat AI and Livegistics. An innovative entrepreneur at the intersection of AI, logistics, and construction technology, Justin is passionate about using technology to solve real-world problems and create economic opportunity.',
    twitter: null,
    linkedIn: null,
    url: null,
    organization: 'ConStrat AI + Livegistics',
    position: '2X Tech Founder',
    session: {
      title:
        'Catalysts and Change Agents: Extending the Impact of Your Tech Leadership',
      abstract:
        'Innovation Summit Panel Discussion on bridging the gap between technical excellence and social responsibility.',
      description:
        'Join our panel on extending the impact of your tech leadership, discussing how to maximize influence while eliminating the "scope creep" of burnout and overcommitment.',
      tags: ['Leadership', 'Entrepreneurship', 'Impact'],
      track: 'Leadership',
      time: '13:00',
      room: 'Main Stage',
    },
    isWTM: false,
    isGDE: false,
    mastodon: null,
  },
]
